module.exports = __webpack_public_path__ + "assets/img/block-right-hover-02f768f4.png";